@if (icon) {
<div fxFlex>
    <forge-icon-button fxFlex [disabled]="!isEnabled" [dense]="dense" (click)="action($event)" [ngClass]="class"
        [attr.aria-label]="ariaLabel" isTelemetryCommand="true" [attr.telemetry]="ariaLabel" [attr.theme]="theme">
        <forge-icon [attr.name]="icon" [ngStyle]="{'--forge-icon-color': iconColor}"></forge-icon>
        {{label}}
    </forge-icon-button>
    @if (isEnabled && tooltip) {
    <forge-tooltip [placement]="tooltipDirection">
        {{tooltip}}
    </forge-tooltip>
    }
    @if (!isEnabled && disabledTooltip) {
    <forge-tooltip placement="bottom">
        {{disabledTooltip}}
    </forge-tooltip>
    }
</div>
} @else {
<forge-button fxFlex variant="outlined" [dense]="compactMode" [disabled]="!isEnabled" (mousedown)="mouseDown($event)"
    (click)="click($event)" [attr.telemetry]="ariaLabel" isTelemetryCommand="true" [attr.aria-label]="ariaLabel"
    class="command-forge-button">
    {{label}}
    @if (isWaiting) {
    <forge-circular-progress slot="end"></forge-circular-progress>
    }
</forge-button>
}